<template>
  <!--代理合同打印 -->
  <div>
    <el-dialog
      :title="$t('functionBtn.print')"
      :visible.sync="dialogVisible"
      width="800px"
      class="splitDialog"
      @close="close"
    >
      <upload :printShow="true" :tableData="tableData || []" @uploadPrint="uploadPrint" />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button  size="medium" type="primary" @click="close"  class="fixed-bottom-btn">确认</el-button> -->
        <el-button size="medium" type="primary" @click="close" class="fixed-bottom-btn"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import AGENCY_API from '@/api/agencyContract/index';
  import upload from '@/components/upload';

  export default {
    props: {
      contractNo: {
        type: String,
        default: '',
      },
    },
    components: {
      upload,
    },
    data() {
      return {
        dialogVisible: false,
        tableData: [],
      };
    },
    methods: {
      // 打开
      openDialog() {
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        const params = {
          handleClass: 'print',
          moduleCode: 'orderTrade',
        };
        this.$axios.post(AGENCY_API.GET_FILE, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data || [];
          }
        });
      },
      //打印或下载
      uploadPrint(val, type) {
        const params = {
          contractNo: this.contractNo,
          downloadOrPrint: 'print',
          templateUrl: val.attachmentKey,
        };
        this.$axios.post(AGENCY_API.EXPORT_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            if (type == 1) {
              // window.location.href = res.data.data.pdf;
              window.open(res.data.data.pdf, '_blank');
            } else {
              window.location.href = res.data.data.word;
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },

      showTip(tip) {
        this.$message({
          showClose: true,
          message: tip,
          type: 'error',
        });
      },
      // 弹窗关闭
      close() {
        this.dialogVisible = false;
      },
    },
  };
</script>
